import { tailwindColors } from '@repo/tailwind-config/tailwind.vars'
import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { MoleculeIcon } from '@repo/ui/icons'
import { useMutation } from '@tanstack/react-query'
import { toast } from 'sonner'

import { createFormula } from '../../../../api/formula/create-formula'
import { Paths } from '../../../../lib/constants/path'
import { twoButtonsConfig } from '../../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../../lib/utils/functions/misc.functions'
import UserNavBar from '../../../elements/nav-bar'
import JourneyPlaceFormulaForm from './journey-place-formula-form'

const JourneyPlaceFormulaCreatePage = () => {
  const { navigate, back } = useNavigator()

  const { mutateAsync } = useMutation({
    mutationFn: createFormula,
    onError: showAxiosError,
    onSuccess: () => toast.success('Formule créée avec succès')
  })

  return (
    <div>
      <UserNavBar
        title={'Créer une formule'}
        icon={(props) => <MoleculeIcon {...props} fill={tailwindColors.secondary.DEFAULT} />}
      />
      <div className={'h-4'} />

      <Box>
        <JourneyPlaceFormulaForm
          defaultValues={{
            displayLongVersionForClientSpace: false,
            category: '',
            code: '',
            description: '',
            translations: []
          }}
          buttonsConfig={twoButtonsConfig({
            onConfirm: async (values) => {
              const res = await mutateAsync(values)
              navigate(Paths.FORMULA_WISH_LIST_UPDATE_PAGE.replace(':id', res.id.toString()), {
                replace: true
              })
            },
            onCancel: () => back()
          })}
        />
      </Box>
    </div>
  )
}

export default JourneyPlaceFormulaCreatePage
